export const SED_DECIMATOR = {
  DEFAULT_PORT: '9784',
  RBW_VALUES: ['300 kHz'],
  VBW_VALUES: ['10', '10'],
  PREAMP_VALUES: ['None'],
  ATTEN_VALUES: [
    'AUTO',
    '0 dB',
    '3 dB',
    '6 dB',
    '9 dB',
    '12 dB',
    '15 dB',
    '18 dB',
    '21 dB',
    '24 dB',
    '27 dB',
    '30 dB',
    '33 dB',
    '36 dB',
    '39 dB',
    '42 dB',
    '45 dB',
  ],
  SWEEP_TIME_ENABLED: false,
  DETECTION_MODE_VALUES: [
    'Normal',
    'Sample',
    'Positive',
    'Negative',
    'Average',
  ],
  IMAGES: {
    connected: 'unit-rx4-connected.png',
    disconnected: 'unit-rx4-disconnected.png',
    lostConnection: 'unit-rx4-lostconnection.png',
  },
  parseIdnResponse: (idnResponse: string) => {
    const splitResponse = idnResponse.split(',');

    return {
      model: splitResponse[0],
      serial: splitResponse[7],
    };
  },
};
